export default {_name:'progress.bar',module:'Field',view:'Element/Progress/Bar',options:{key:'progressBar',color:'primary.main',value:0,xs:'auto',ms:'auto'}}